export type PresetAudience = 'student' | 'professional' | 'all';

export interface CanvasPreset {
  id: string;
  name: string;
  width: number;
  height: number;
  audience: PresetAudience;
  description: string;
}

export const CANVAS_PRESETS: CanvasPreset[] = [
  {
    id: 'presentation',
    name: 'Presentation slide',
    width: 1920,
    height: 1080,
    audience: 'all',
    description: 'Lectures, decks, class reports',
  },
  {
    id: 'poster-a4',
    name: 'Poster / A4',
    width: 2480,
    height: 3508,
    audience: 'student',
    description: 'Academic posters & printouts',
  },
  {
    id: 'square',
    name: 'Square post',
    width: 1080,
    height: 1080,
    audience: 'all',
    description: 'Instagram / portfolio tiles',
  },
  {
    id: 'story',
    name: 'Story / vertical',
    width: 1080,
    height: 1920,
    audience: 'all',
    description: 'Stories, reels, mobile flyers',
  },
  {
    id: 'linkedin',
    name: 'LinkedIn banner',
    width: 1200,
    height: 627,
    audience: 'professional',
    description: 'Profile & company covers',
  },
  {
    id: 'youtube',
    name: 'YouTube thumbnail',
    width: 1280,
    height: 720,
    audience: 'professional',
    description: 'Course & content thumbnails',
  },
  {
    id: 'business-card',
    name: 'Business card',
    width: 1050,
    height: 600,
    audience: 'professional',
    description: 'Networking & print cards',
  },
  {
    id: 'certificate',
    name: 'Certificate',
    width: 1920,
    height: 1358,
    audience: 'student',
    description: 'Awards, completion docs',
  },
  {
    id: 'custom',
    name: 'Custom size',
    width: 1200,
    height: 800,
    audience: 'all',
    description: 'Set your own dimensions',
  },
];

export const QUICK_START_FILTERS = [
  { id: 'all', label: 'All sizes' },
  { id: 'student', label: 'For students' },
  { id: 'professional', label: 'For professionals' },
] as const;
